import React from 'react';

// Containers
import ModalContainer from '../containers/ModalContainer';
import Notifier from '../containers/Notifier';
import ContactContainer from '../containers/ContactOptionsContainer';
import TopicTreeSwitch from '../containers/TopicTreeSwitch';
import ActiveArticle from '../containers/ActiveArticle';
import AlertsContainer from '../containers/Alerts';
import ErrorHandler from '../containers/ErrorHandler';
import EmailUs from '../containers/EmailUs';
import Page from '../../lib/page';

const ContactUs = () => (
  <ErrorHandler>
    <div className="page-main-container" role="main">
      <AlertsContainer />
      {!Page.isTopicTreeDisabled() && <TopicTreeSwitch />}
      <Notifier />
      <ModalContainer />
      <ActiveArticle />
      <ContactContainer />
      <EmailUs />
    </div>
  </ErrorHandler>
);

export default ContactUs;
